/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import objectUtils from './object';

export const parseData = (obj) =>
  Object.keys(obj).reduce((acc, currkey) => {
    const currentValue = obj[currkey];
    let value = currentValue;
    if (Array.isArray(currentValue)) {
      value = currentValue.map((itemArray) => (typeof itemArray === 'object' ? parseData(itemArray) : itemArray));
    } else if (objectUtils.isObject(currentValue)) {
      value = parseData(currentValue);
    } else if (typeof currentValue === 'string' && /^\d{4}-\d{2}-\d{2}/.test(currentValue)) {
      const isUtcFormat = /z$/i.test(currentValue);
      value = isUtcFormat ? moment.utc(currentValue) : moment(currentValue);
    }

    return {
      ...acc,
      [currkey]: value,
    };
  }, {});
